import { isBefore, isAfter, isWithinInterval, parseISO, startOfDay, endOfDay } from 'date-fns';

/**
 * Determines the status of an event based on current date
 */
export const getEventStatus = (startDateStr, endDateStr) => {
  const now = new Date();
  const start = startOfDay(parseISO(startDateStr));
  // Default to start date if no end date provided
  const end = endOfDay(parseISO(endDateStr || startDateStr));

  if (isWithinInterval(now, { start, end })) {
    return { label: 'Ongoing', color: 'bg-green-500' };
  }
  
  if (isBefore(now, start)) {
    return { label: 'Upcoming', color: 'bg-blue-500' };
  }
  
  if (isAfter(now, end)) {
    return { label: 'Expired', color: 'bg-gray-400' };
  }

  return { label: 'Scheduled', color: 'bg-brand-navy' };
};